import script from "./SourceSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./SourceSettings.vue?vue&type=script&setup=true&lang=js"

import "./SourceSettings.vue?vue&type=style&index=0&id=6988ddda&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6988ddda"]])

export default __exports__